import ReactGA from 'react-ga4'
import { trackMailjetCampaignEvent } from '@/lib/mailjetCampaignTracking'

const isBrowser = typeof window !== 'undefined'

const gaAddPaymentInfo = (basket, selectPaiement) => {
  if (isBrowser) {
    const items = []
    basket.product_groups.forEach(product_groups => {
      product_groups?.products.forEach(product => {
        items.push({
          item_id: product.product_id,
          item_name: product.product,
          price: product.price,
          item_category: product.category_id,
          quantity: product.amount,
        })
      })
    })
    ReactGA.event('add_payment_info', {
      currency: 'EUR',
      value: basket.total,
      payment_type:
        basket.payments.find(payment => payment.id == selectPaiement)?.payment_type || '',
      items,
    })

    /* ReactGA.event('add_shipping_info', {
      currency: 'EUR',
      value: basket.shipping_cost,
      coupon: basket.coupon?.[0] || '',
      shipping_tier: 'Ground',
      items: basket?.product_groups.map(shippingGroups => ({
        item_id: shippingGroups.company_id,
      })),
    })*/
  }
}

const gaAddToCart = (product, quantity) => {
  if (isBrowser) {
    const event = {
      currency: 'EUR',
      value: product.price,
      items: [
        {
          location_id: product.company_id,
          affiliation: product.company_name,
          item_id: product.product_id,
          item_name: product.product,
          item_brand: product.brand_name,
          brand_seo_name: product.brand_seo_name,
          price: product.price,
          item_category: product.main_category,
          quantity: quantity,
        },
      ],
    }
    ReactGA.event('add_to_cart', event)
    trackMailjetCampaignEvent('campaign_add_to_cart', {
      landingPage: window.location.pathname,
      amount: Number(product.price) * Number(quantity),
      currency: 'EUR',
    })
  }
}

const gaRemoveToCart = product => {
  if (isBrowser) {
    const event = {
      currency: 'EUR',
      value: product.price,
      items: [
        {
          location_id: product.company_id,
          affiliation: product.company_name,
          item_id: product.product_id,
          item_name: product.product,
          item_brand: product.brand_name,
          brand_seo_name: product.brand_seo_name,
          price: product.price,
          item_category: product.main_category,
          quantity: product.amount,
        },
      ],
    }

    ReactGA.event('remove_from_cart', event)
  }
}

const gaViewProduct = product => {
  const event = {
    currency: 'EUR',
    value: product.price,
    items: [
      {
        location_id: product.company_id,
        affiliation: product.company_name,
        item_id: product.product_id,
        item_name: product.product,
        item_brand: product.brand_name,
        brand_seo_name: product.brand_seo_name,
        price: product.price,
        item_category: product.main_category,
        quantity: 1,
      },
    ],
  }

  ReactGA.event('view_item', event)
}

const gaViewListProduct = products => {
  const event = {
    item_list_id: 'related_products',
    item_list_name: 'Related products',
    items: products.map(product => {
      return {
        location_id: product.company_id,
        affiliation: product.company_name,
        item_id: product.product_id,
        item_name: product.product,
        item_brand: product.brand_name,
        brand_seo_name: product.brand_seo_name,
        price: product.price,
        item_category: product.main_category,
        quantity: 1,
      }
    }),
  }

  ReactGA.event('select_item', event)
}

export { gaAddPaymentInfo, gaAddToCart, gaRemoveToCart, gaViewProduct, gaViewListProduct }
